import React from 'react';
import { getConfig } from '../../../utils/config';

function List(props) {
    const { points, classNameContainer, listClassName, listStyle, fontBody } =
        props;
    const config = getConfig();
    console.log('LIST', props);
    return (
        <div
            className={`${classNameContainer} ${
                listClassName
                    ? listClassName
                    : 'text-black font-normal text-[17px] leading-7'
            } ${config?.termsAndConditions?.fontBody}`}
        >
            <ul className={`${listStyle ? listStyle : 'list-disc'}`}>
                {points?.map((point) => (
                    <li className={``}>{point}</li>
                ))}
            </ul>
        </div>
    );
}

export default List;
